/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";
import { decimalRound, getImperialOnValue } from "../utils/featureAnalysisUtils";

const useScenarioFeatures = (scenarioFeatures, units, setFeatureValueList) => {

    useEffect(() => {
        if (units) {
            const convertedList = scenarioFeatures?.map((obj) =>
                Object.values(obj)[0] && typeof Object.values(obj)[0] !== "string"
                    ? decimalRound(getImperialOnValue(Object.keys(obj)[0], Object.values(obj)[0]), Object.keys(obj)[0])
                    : Object.values(obj)[0]
            );
            setFeatureValueList(convertedList);
        } else {
            const fValue = scenarioFeatures?.map((obj) =>
                Object.values(obj)[0] && typeof Object.values(obj)[0] !== "string"
                    ? decimalRound(Object.values(obj)[0], Object.keys(obj)[0])
                    : Object.values(obj)[0]
            );
            setFeatureValueList(fValue);
        }
    }, [scenarioFeatures, units]);

};


export default useScenarioFeatures;